var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMother(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_382",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29210",
    "data-name": "Group 29210",
    transform: "translate(435 11197)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -435, -11197)",
    filter: "url(#Ellipse_382)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_382-2",
    "data-name": "Ellipse 382",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_3_",
    "data-name": "svgexport-17 (3)",
    transform: "translate(-409.981 -11180.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49921",
    "data-name": "Path 49921",
    d: "M107.847,19.577l-.963-.871a2.963,2.963,0,0,1-.976-2.2V6.322A6.322,6.322,0,0,0,99.586,0h-4.04a3.419,3.419,0,0,0-2.7,1.322l-.518.667a1.694,1.694,0,0,1-1.338.655A2.217,2.217,0,0,0,88.773,4.86V16.508a2.964,2.964,0,0,1-.976,2.2l-.963.871a2.964,2.964,0,0,0,1.734,5.151c2.19.2,6.574.137,8.772.137s6.583.06,8.772-.137a2.964,2.964,0,0,0,1.734-5.151Z",
    transform: "translate(-85.859 0)",
    fill: "#302d31"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28914",
    "data-name": "Group 28914",
    transform: "translate(7.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49922",
    "data-name": "Path 49922",
    d: "M198.97,24.864c-.621,0-1.417,0-2.288.007,1.128,0,2.235,0,3.145-.005Zm12.222-5.288-.963-.871a2.964,2.964,0,0,1-.976-2.2V6.322A6.322,6.322,0,0,0,202.931,0h-1.715a6.322,6.322,0,0,1,6.322,6.322V16.508a2.964,2.964,0,0,0,.975,2.2l.963.871a2.964,2.964,0,0,1-1.734,5.151c-1.181.106-3,.138-4.769.144,2.213.006,4.913,0,6.485-.144a2.964,2.964,0,0,0,1.734-5.151Z",
    transform: "translate(-196.682 0)",
    fill: "#282429"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_49923",
    "data-name": "Path 49923",
    d: "M127.6,275.969c4.5,0,8.369,3.069,9.149,11.8a3.707,3.707,0,0,1-.836,2.964,2.931,2.931,0,0,1-2.148,1.168H118.982a.7.7,0,0,1-.671-.725c0-11.349,4.247-15.2,9.292-15.2Z",
    transform: "translate(-116.121 -257.346)",
    fill: "#acd980"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49924",
    "data-name": "Path 49924",
    d: "M243.58,275.969q-.454,0-.9.043c4.64.447,8.393,4.492,8.393,15.16a.7.7,0,0,1-.671.725s1.324-.128,1.566-.446a8.4,8.4,0,0,0,.761-3.676C251.952,279.04,248.083,275.969,243.58,275.969Z",
    transform: "translate(-232.098 -257.346)",
    fill: "#8cc951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49925",
    "data-name": "Path 49925",
    d: "M340.409,448.467c.134,1.273.212,2.7.225,4.287h2.7a.7.7,0,0,0,.671-.725q0-1.922-.158-3.562Z",
    transform: "translate(-323.231 -418.203)",
    fill: "#f2d1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49926",
    "data-name": "Path 49926",
    d: "M359.419,448.467h-1.8c.1,1.1.158,2.28.158,3.562a.7.7,0,0,1-.671.725h1.8a.638.638,0,0,0,.428-.166.749.749,0,0,0,.243-.559C359.577,450.844,359.527,449.612,359.419,448.467Z",
    transform: "translate(-338.803 -418.203)",
    fill: "#f2bb88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49927",
    "data-name": "Path 49927",
    d: "M118.469,448.467q-.155,1.643-.158,3.562a.7.7,0,0,0,.671.726h2.7c.013-1.59.092-3.015.225-4.287Z",
    transform: "translate(-116.121 -418.203)",
    fill: "#f2d1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49928",
    "data-name": "Path 49928",
    d: "M193.947,272.39a11.014,11.014,0,0,0-.6-2.191,3.2,3.2,0,0,0-2.99-2.035h-2.427a3.224,3.224,0,0,0-3.013,2.092,10.987,10.987,0,0,0-.577,2.134,1.89,1.89,0,0,0,.494,1.765,1.836,1.836,0,0,0,1.324.333,8.087,8.087,0,0,0,2.661-.687.785.785,0,0,1,.649,0,8.087,8.087,0,0,0,2.661.687,1.836,1.836,0,0,0,1.324-.333A1.89,1.89,0,0,0,193.947,272.39Z",
    transform: "translate(-177.662 -250.068)",
    fill: "#edf6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49929",
    "data-name": "Path 49929",
    d: "M223.478,220.479v4.168a3.984,3.984,0,0,0,.312,1.472,2.03,2.03,0,0,0,3.765,0,3.984,3.984,0,0,0,.312-1.472v-4.168Z",
    transform: "translate(-214.191 -205.601)",
    fill: "#f2d1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49930",
    "data-name": "Path 49930",
    d: "M223.478,223.729a6.06,6.06,0,0,0,3.029.971,4.98,4.98,0,0,0,1.361-.217v-4h-4.39Z",
    transform: "translate(-214.191 -205.601)",
    fill: "#f2bb88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49931",
    "data-name": "Path 49931",
    d: "M180.074,92.1a5.949,5.949,0,1,1-11.847,0,12.334,12.334,0,0,1,.208-2.374,5.425,5.425,0,0,0,2.514-1.925.4.4,0,0,1,.567-.088,10.714,10.714,0,0,0,8.3,1.782,11.884,11.884,0,0,1,.257,2.6Z",
    transform: "translate(-162.669 -81.725)",
    fill: "#f2d1a5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28915",
    "data-name": "Group 28915",
    transform: "translate(8.15 9.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49932",
    "data-name": "Path 49932",
    d: "M212.77,147.5a.521.521,0,0,1-.521-.521v-.217a.521.521,0,1,1,1.043,0v.217A.521.521,0,0,1,212.77,147.5Zm-5.621,0a.521.521,0,0,1-.521-.521v-.217a.521.521,0,1,1,1.043,0v.217A.521.521,0,0,1,207.148,147.5Zm2.811,2.935a2.542,2.542,0,0,1-1.52-.553.521.521,0,1,1,.621-.838,1.341,1.341,0,0,0,1.8,0,.521.521,0,1,1,.621.838A2.541,2.541,0,0,1,209.959,150.433Z",
    transform: "translate(-206.627 -146.239)",
    fill: "#302d31"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMother);
export default __webpack_public_path__ + "static/media/Mother.2fcf45f4c37e91783c7a09245d909aa5.svg";
export { ForwardRef as ReactComponent };